import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/remote-call';

export const useCalendarHoliday = () => {
  const query = useQuery({
    queryKey: ['calendarHolidays'],
    queryFn: () =>
      callService({
        service: 'ContentsService',
        version: 'v3',
        method: 'getCalendarHolidays',
      }),
    staleTime: 1000 * 60 * 30,
    cacheTime: 1000 * 60 * 30,
  });

  return query;
};
